// libs
import { styled } from '@nykaa/ui-components';

// constants
import { BREAKPOINTS } from 'shared/styles/base';

// component
import Button from 'shared/components/Button';

export const AddToCartBtn = styled(Button)<{ wishlistEnabled: boolean; disabled: boolean }>`
  width: 100%;
  height: 48px;
  transform: translateZ(0);
  ${({ theme }) => theme.typography.titleSmall}
  ${({ disabled, theme }) => (disabled ? theme.colors.textDisabled : theme.colors.primary)};
  &:focus-visible {
    outline: 1px solid ${({ theme }) => theme.colors.secondary};
    outline-offset: 1px;
  }
  @media (max-width: ${BREAKPOINTS.DESKTOP}px) {
    ${({ wishlistEnabled }) => (wishlistEnabled ? `width: calc(100% - 64px);` : `width: 100%;`)}
    margin: 0 auto;
  }
`;

export const ViewBagBtn = styled(AddToCartBtn)`
  background-color: ${({ theme }) => theme.colors.secondary};
  ${({ theme }) => theme.typography.titleSmall}

  &:hover {
    background: ${({ theme }) => theme.colors.secondary};
  }
`;
